<template>
  <div class="popWrap" style="overflow:auto;">
    <div class="popup">
      <div class="popContain">
        <div class="popCont">
          <div class="popHead">
            <h1 class="titH1">전체 상품 조회</h1>
          </div>
          <div class="popBody">
            <div class="popInner">
              <section>
                <div class="searchWrap">
                  <input
                    type="text"
                    id="ipt1_1"
                    class="ipt"
                    placeholder="검색어를 입력해주세요"
                    title="검색어 입력"
                    value=""
                    v-model="keyword"
                    @keyup="inputEnter"
                  />
                  <button type="button" class="btnIco_srch" @click="searchProductForKeyword"><span>검색</span></button>
                </div>
              </section>

              <section v-if="productListLength > 0">
                <ul class="prdList line">
                  <li v-for="(product, productIndex) in productList" :key="productIndex">
                    <div class="block">
                      <div class="prdItem xs">
                        <div class="imgArea">
                          <span class="img"><img :src="product.thumbnail" :alt="product.displayName" /></span>
                        </div>
                        <div class="infoArea">
                          <div class="tit row2">
                            <span v-text="product.productName"></span>
                          </div>
                          <div class="txtItem">
                            <span v-text="product.model"></span>
                          </div>
                        </div>

                        <div class="btnGroup">
                          <button type="button" class="btn_s s" @click="selectProduct(product)">선택</button>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </section>

              <section v-if="productListLength == 0">
                <div class="resultMsg noSrch">
                  <p class="copy">검색 결과가 없습니다.</p>
                </div>
              </section>
            </div>
          </div>

          <button type="button" class="btnIco_close" @click="$emit('close')"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
    <MessagePop v-if="messagePop" @close="messagePop = false">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
</template>

<script>
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';
import { isEmpty } from '@/common/common.function';
import * as customjs from '@/../static/js/m.front.js';

export default {
  name: 'AllProductSearchPop',
  components: {
    MessagePop,
  },
  data: function() {
    return {
      productList: [],
      productListLength: null,

      keyword: null,

      msg: null,
      messagePop: null,
    };
  },
  updated() {
    customjs.listInit();
  },
  methods: {
    searchProductForKeyword: function() {
      if (isEmpty(this.keyword)) {
        this.msg = '검색어를 입력하세요.';
        this.messagePop = true;
        return false;
      }

      ApiService.service('GET', '/product/keyword/' + this.keyword)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.productList = data.result.content;
            this.productListLength = data.result.content.length;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    selectProduct: function(product) {
      let resultObj = new Object();
      resultObj.orderId = '';
      resultObj.product = product;

      this.$emit('selectItem', resultObj);
    },
    inputEnter() {
      if (window.event.keyCode == 13) {
        this.searchProductForKeyword();
      }
    },
  },
};
</script>
